"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfFontInfoCollection = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var rtf_font_info_1 = require("./rtf-font-info");
var RtfFontInfoCollection = (function () {
    function RtfFontInfoCollection() {
        this.defaultRtfFontInfo = rtf_font_info_1.RtfFontInfo.createDefaultRtfFontInfo();
        this.collection = [];
    }
    RtfFontInfoCollection.prototype.getRtfFontInfoById = function (id) {
        var font = list_1.ListUtils.elementBy(this.collection, function (font) { return font.id == id; });
        return font ? font : this.defaultRtfFontInfo;
    };
    return RtfFontInfoCollection;
}());
exports.RtfFontInfoCollection = RtfFontInfoCollection;
